;(function () {
  const clipBoard = () => {
    return {
      copyText: function (field, label) {
        var copyText = document.getElementById(field)

        if (window.isSecureContext && navigator.clipboard) {
          navigator.clipboard.writeText(copyText.value)

          toastr.success(label + ' copied.')
        } else {
          toastr.error(label + ' not copied, check your browser permissions.')
        }
      }
    }
  }

  if (typeof window !== 'undefined') {
    window.clipBoard = clipBoard
  }
  return clipBoard
})()
